import { graphql } from 'app/generated/gql'
import type { Client } from '@urql/core'

import type { ConversionLogItem as ConversionLogType, ConversionLogListResult } from 'app/generated/graphql'
import { EntityStore } from './EntityStore'

const CONVERSION_LOG_FIELDS = `becameLeadDate becamePatientDate contactId contactName conversionDateTime conversionType conversionValue createdDate errorMessage firstAppointmentMadeDate gclid googleAdsAccountId id locationId status`

const LIST_QUERY = graphql(`
  query ConversionLogs($search: String, $pagination: PaginationInput, $sort: SortInput) {
    conversionLogs(search: $search, pagination: $pagination, sort: $sort) {
      hits {
        becameLeadDate
        becamePatientDate
        contactId
        contactName
        conversionDateTime
        conversionType
        conversionValue
        createdDate
        errorMessage
        firstAppointmentMadeDate
        gclid
        googleAdsAccountId
        id
        locationId
        status
      }
      total
      page
    }
  }
`)

export class ConversionLogStore extends EntityStore<ConversionLogType, ConversionLogListResult> {
  constructor(client: Client) {
    super(client, {
      listQuery: LIST_QUERY,
      getQuery: undefined,
      extractList: (data: any) => data.conversionLogs,
    })
  }
}
